import { render, staticRenderFns } from "./Grading.vue?vue&type=template&id=c17e1838"
import script from "./Grading.vue?vue&type=script&lang=js"
export * from "./Grading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports